<template>
  <div>{{ time }}</div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CountdownComponent',
  props: {
    countdown: {},
  },
  data() {
    return {
      diff: {
        hours: '',
        minutes: '',
        seconds: '',
      },
      diffSeconds: null,
    };
  },
  computed: {
    time: function () {
      return `${this.diff.hours}:${this.diff.minutes}:${this.diff.seconds}`;
    },
  },
  watch: {
    diffSeconds: function (newVal) {
      this.$emit('seconds', newVal);
    }
  },
  methods: {},
  mounted() {
    setInterval(() => {
      const end = moment(this.countdown);
      const diff = moment.duration(end.diff());

      this.diff.hours = String(Math.floor(diff.asHours())).padStart(2, '0');
      this.diff.minutes = String(diff.minutes()).padStart(2, '0');
      this.diff.seconds = String(diff.seconds()).padStart(2, '0');
      this.diff.seconds = String(diff.seconds()).padStart(2, '0');
      this.diffSeconds = Math.floor(diff.asSeconds());
    }, 100);
  }
};
</script>